/**
 * Build absolute API URLs in production / when REACT_APP_BACKEND_URL is set.
 * In local dev without env, returns the path as-is so Create React App proxy
 * can forward /api/* to the backend (see package.json "proxy").
 */
export function apiUrl(path) {
  const base = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  if (!path.startsWith('/')) {
    path = `/${path}`;
  }
  return base ? `${base}${path}` : path;
}
